import { Button } from "@/components/ui/button";
import { ChevronLeft, ChevronRight, ChevronsLeft, ChevronsRight } from "lucide-react";

export function Pagination({ page, totalPages, total, perPage, onPageChange }) {
  if (totalPages <= 1) return null;
  
  const start = (page - 1) * perPage + 1;
  const end = Math.min(page * perPage, total);
  
  const getPageNumbers = () => {
    const pages = [];
    const maxVisible = 5;
    let startPage = Math.max(1, page - Math.floor(maxVisible / 2));
    let endPage = Math.min(totalPages, startPage + maxVisible - 1);
    if (endPage - startPage < maxVisible - 1) {
      startPage = Math.max(1, endPage - maxVisible + 1);
    }
    for (let i = startPage; i <= endPage; i++) pages.push(i);
    return pages;
  };
  
  return (
    <div className="flex items-center justify-between pt-4 border-t border-slate-200" data-testid="pagination">
      <span className="text-sm text-slate-500">
        {start}–{end} of {total.toLocaleString()}
      </span>
      <div className="flex items-center gap-1">
        <Button variant="outline" size="sm" className="h-8 w-8 p-0 rounded-none" onClick={() => onPageChange(1)} disabled={page === 1} data-testid="page-first">
          <ChevronsLeft size={14} />
        </Button>
        <Button variant="outline" size="sm" className="h-8 w-8 p-0 rounded-none" onClick={() => onPageChange(page - 1)} disabled={page === 1} data-testid="page-prev">
          <ChevronLeft size={14} />
        </Button>
        {getPageNumbers().map((p) => (
          <Button key={p} variant={p === page ? "default" : "outline"} size="sm" className={`h-8 w-8 p-0 rounded-none ${p === page ? "bg-slate-900 text-white" : ""}`} onClick={() => onPageChange(p)} data-testid={`page-${p}`}>
            {p}
          </Button>
        ))}
        <Button variant="outline" size="sm" className="h-8 w-8 p-0 rounded-none" onClick={() => onPageChange(page + 1)} disabled={page === totalPages} data-testid="page-next">
          <ChevronRight size={14} />
        </Button>
        <Button variant="outline" size="sm" className="h-8 w-8 p-0 rounded-none" onClick={() => onPageChange(totalPages)} disabled={page === totalPages} data-testid="page-last">
          <ChevronsRight size={14} />
        </Button>
      </div>
    </div>
  );
}
